export const TEACHER_LIST = 'TEACHER_LIST';
export const TEACHER_LIST_SUCCESS = 'TEACHER_LIST_SUCCESS';
export const ADD_NEW_TEACHER = 'ADD_NEW_TEACHER';
export const DELETE_TEACHER = 'DELETE_TEACHER';
export const EDIT_TEACHER = 'EDIT_TEACHER';
export const ASSIGNED_TEACHER = 'ASSIGNED_TEACHER';
export const ASSIGNED_TEACHER_SUCCESS = 'ASSIGNED_TEACHER_SUCCESS';
export const SET_LOADER = 'SET_LOADER';
export const GET_TEACHER_DETAIL = 'get_teacher_detail';
export const GET_TEACHER_DETAIL_SUCCESS = 'get_teacher_detail_success';